import { scan } from "react-scan";
import './App.css';
import { RouterProvider } from 'react-router-dom';
import router from "./router";
import React, { useEffect } from 'react';
import { Spin } from "antd";
import { refreshAccessToken } from './services/api-service';
import { Provider } from 'react-redux';
import store from "./redux/store";
import OperationNotificationsContainer from "./components/operations/OperationNotificationsContainer";
import ScrollHandler from "./components/infrastructure/ScrollHandler";

// Включаем scan только в режиме разработки
if (process.env.NODE_ENV === 'development') {
  scan({
    enabled: true,
  });
}

// Вынесенная функция tryAutoLogin
const getCurrentHashPath = (): string => {
  const hash = window.location.hash || '#/';
  const path = hash.startsWith('#') ? hash.slice(1) : hash;
  return path || '/';
};

const tryAutoLogin = async (): Promise<void> => {
  const refreshToken = localStorage.getItem('refresh_token');
  if (refreshToken) {
    try {
      const newAccessToken = await refreshAccessToken();
      if (newAccessToken) {
        const currentPath = getCurrentHashPath();
        const targetPath = currentPath !== '/' && currentPath !== '/login'
          ? currentPath
          : '/documents';
        await router.navigate(targetPath);
      } else {
        await router.navigate('/login');
      }
    } catch (error) {
      console.error("Error during auto login:", error);
      await router.navigate('/login');
    }
  } else {
    await router.navigate('/login');
  }
};

const App: React.FC = () => {
  useEffect(() => {
    tryAutoLogin().catch(error => {
      console.error("Error initializing app:", error);
    });
  }, []);

  return (
      <Provider store={store}>
        <ScrollHandler />
        <OperationNotificationsContainer />
        <RouterProvider router={router} fallbackElement={<Spin size="large" />} />
      </Provider>
  );
};

export default App;
